import React, { useCallback, useEffect, useState } from "react";
import { Spin, Select, Checkbox, Form, Button, Table, Image, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";

import {
  getGenderCategory,

} from "../../redux/actions/genderCategory.action";
import { getProductStatus } from "../../redux/actions/productStatus.actions";
import { getProductClass } from "../../redux/actions/productClass.action";
import { getFitCategory } from "../../redux/actions/fitCategory.action";
import { getProductType } from "../../redux/actions/productType.action";
import { getSeason } from "../../redux/actions/season.action";
import { getGender } from "../../redux/actions/gender.action";
import { getSize } from "../../redux/actions/size.action";
import { getSku } from "../../redux/actions/sku.action";
import { ReadCookie } from "../../utils/readCookie";
import { getWashName } from "../../redux/actions/wash.action";
import {
  getStyle,

} from "../../redux/actions/style";
import moment from "moment";
import btnPrint from "../../assets/images/button_print.gif";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import logo from "../../assets/images/logo.png";
import "../Distributor/Distributor.css";
import { Link, useHistory } from "react-router-dom";

import Loader from "react-loader-spinner";
import numeral from "numeral";
import { TabTitle } from "../../utils/GeneralFunction";
import { CSVLink } from "react-csv";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { getSeasonYear } from "../../redux/actions/seasonYear.action";
import { imediateOtsBySize } from "../../redux/actions/omsStockSummary2.action";
import { getAdminLocation } from "../../redux/actions/adminLocation.action";
import { getskuloopUpData, getskuloopUpDataPkStock } from "../../redux/actions/skuLookupData.action";
import { useRef } from "react";
import { BASEURL } from "../../constant/config";
import axios from "axios";
import { saveAs } from "file-saver";
import { allSizes, createNestedColumn, kidsSizes, menSizes, womenSizes } from "../../utils/sizeChart";


const TotalOtsPk = ({ token }) => {
  TabTitle("Total OTS PK");
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const {
    style,
    gender,
    genderCategory,
    season,
    productStatus,
    wash,
    skuLookUpDataPkStock,
    genderCategoryChange,
    styleChange,
    Sku,

    adminLocation,
  } = useSelector((state) => state);

  const menuId = ReadCookie("menuId");
  const userName = ReadCookie("name");
  const [isChecked, setIsChecked] = useState([]);
  const [isChecked2, setIsChecked2] = useState([]);
  const [allSesion, setAllSesion] = useState(true);
  const [allStatus, setAllStatus] = useState(true);
  const [isPCChecked, setIsPCChecked] = useState([]);
  const [allPC, setAllPC] = useState(true);
  const [loading, setLoading] = useState(false);
  const [BgradeCheck, setBgradeCheck] = useState(false);
  const [check, setCheck] = useState(false);
  const [data, setData] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const [steps, setSteps] = useState([]);
  const [allFilters, setAllFilters] = useState([
    "BERGEN ECOM",
    "NORD D2C",
    "Saks D2C",
    "Neiman D2C",
    "Moda D2C",
    "Macys D2C",
    "Anthro D2C"
  ]);
  const [filters, setFilters] = useState([]);
  const stepsArr = [1, 17, 18, 25, 106, 2, 29, 20, 21, 22, 28, 33, 108, 109];
  const [pendingChecked, setPendingChecked] = useState(true);
  const location = useLocation();
  const tableRef = useRef(null);
  const [stepsChecked, setStepChecked] = useState([]);
  const [isGenerate, setIsGenerate] = useState("All");
  const [isSKU, setIsSKU] = useState("All");


  useEffect(() => {
    if (adminLocation?.payload?.data?.length > 0) {
      setSteps(
        adminLocation?.payload?.data
          .filter((val) => stepsArr.includes(val.location_id))
          .map((it) => ({ ...it, selected: true }))
      );
    }
  }, [adminLocation]);

  const stepschecked =
    steps && steps?.filter((it) => it.selected)?.map((it) => it.location_id);

  const values = {
    item_id: null,
    location_id: null,
  };

  const { Option } = Select;

  const statusSelectAll = (e) => {
    setAllStatus(e.target.checked);
  };

  const isCheckboxChecked2 = (id, value) => {
    const filterCheckBox =
      productStatus &&
      productStatus?.payload?.data.find((val) => val.product_status_id === id);
    const checkId = isChecked2.includes(id);
    if (!checkId) {
      setIsChecked2((current) => [
        ...current,
        filterCheckBox.product_status_id,
      ]);
    }
    if (!value) {
      const removeUnCheck = isChecked2.filter(
        (item) => item !== filterCheckBox.product_status_id
      );
      setIsChecked2(removeUnCheck);
    }
    setAllStatus(false);
  };

  const isFilter = (id, value) => {
    let checkId = filters.includes(id);
    if (!checkId) {

      filters.push(id);
      setFilters(filters);
    }
    if (!value) {
      let removeUnCheck = filters.filter((item) => item !== id);
      filters.length = 0;
      filters.push(...removeUnCheck);
    }

  };

  useEffect(() => {
    if (location?.state && location?.state?.values?.new_season_id) {
      const values = {
        as_on_date: moment("12-31-2023"),
        sku: "",
        season_id: location?.state?.values?.new_season_id,
        gender_id: location?.state?.values?.gender_id,
        gender_category_id: null,
        fit_category_id: null,
        style_id: null,
        product_status_id: null,
        product_class_id: null,
        sort_on: null,
        include_bgrade: "abc",
        wash_id: null,
      };
      form.setFieldsValue({
        season_id: values.season_id,
        gender_id: values.gender_id,
      });
      setLoading(true);
      dispatch(
        imediateOtsBySize(
          token,
          values,
          isChecked,
          isChecked2,
          isPCChecked,
          BgradeCheck
        )
      ).then((res) => {
        setLoading(false);
        setData(res?.payload?.data);
        // downloadExcelFileData(res?.payload?.data);
      });
    }
  }, [location?.state && location?.state?.values?.new_season_id]);

  const onFinish = async (e) => {
    await form.setFieldsValue({
      gender_id: isGenerate,
      sku: isSKU
    });
    await form.validateFields().then((values) => {
      values.stepsChecked = stepsChecked;
      values.isChecked = isChecked;
      values.isChecked2 = isChecked2;
      if (allStatus) {
        values.allStatus = allStatus;
      }
      if (pendingChecked) {
        stepschecked.push(-1);
      }
      const productStatusId =
        productStatus &&
        productStatus?.payload?.data.find(
          (val) => val.product_status_id === values.product_Status
        );
      const distributorParam = {
        location_id: null,
        season_id: values.season_id === "All" ? null : values.season_id,
        sku: isSKU === "All" ? null : isSKU,
        gender_category_id: values.type === "All" ? null : values.type,

        style_id: values.style_id === "All" ? null : values.style_id,
        product_status_id: isChecked2.length > 0 ? isChecked2.toString() : null,
        pending_date: moment(values.as_on_date).format("YYYY-MM-DD"),
        as_on_date: moment(values.as_on_date).format("YYYY-MM-DD"),
        category_id:
          values.gender_category_id === "All"
            ? null
            : values.gender_category_id,
        fit_category_id: null,
        gender_id: isGenerate === "All" ? null : isGenerate,
        product_class_id: null,
        sort_on: null,
        include_bgrade: "abc",
        wash_id: values.wash_id === "All" ? null : values.wash_id,
        new_sesaon_year_id:
          values.new_season_year_id === "All"
            ? null
            : values.new_season_year_id,
      };
      setLoading(true);
      dispatch(getskuloopUpDataPkStock(token, distributorParam)).then((res) => {
        setLoading(false);
        setData(res?.payload?.data);
        // downloadExcelFileData(res?.payload?.data);
      });
    });
  };

  const notificationKey = `open${Date.now()}`;
  const load = <div className="d-flex"><span className="spin-color mx-2">
    <Spin size="small" />
  </span><p>Please wait for a few minutes</p></div>;

  const handleDownload = async () => {
    try {
      // form.setFields("gender_id",isGenerate)
      notification.open({
        message: "Preparing Excel Download...",
        description: load,
        key: notificationKey,
        duration: 0,
      });

      await form.setFieldsValue({
        gender_id: isGenerate,
        sku: isSKU
      });
      await form.validateFields().then(async (values) => {
        values.stepsChecked = stepsChecked;
        values.isChecked = isChecked;
        values.isChecked2 = isChecked2;
        if (allStatus) {
          values.allStatus = allStatus;
        }
        if (pendingChecked) {
          stepschecked.push(-1);
        }
        const styleId =
          style &&
          style?.payload?.data.find((val) => val.style_name === values.style);
        const productStatusId =
          productStatus &&
          productStatus?.payload?.data.find(
            (val) => val.product_status_id === values.product_Status
          );
        const distributorParam = {
          location_id: null,
          season_id: values.season_id === "All" ? null : values.season_id,
          sku: isSKU === "All" ? null : isSKU,
          gender_category_id: values.type === "All" ? null : values.type,

          style_id: values.style_id === "All" ? null : values.style_id,
          product_status_id: isChecked2.length > 0 ? isChecked2.toString() : null,
          pending_date: moment(values.as_on_date).format("YYYY-MM-DD"),
          as_on_date: moment(values.as_on_date).format("YYYY-MM-DD"),
          category_id:
            values.gender_category_id === "All"
              ? null
              : values.gender_category_id,
          fit_category_id: null,
          gender_id: isGenerate === "All" ? null : isGenerate,
          product_class_id: null,
          sort_on: null,
          include_bgrade: "abc",
          wash_id: values.wash_id === "All" ? null : values.wash_id,
          new_sesaon_year_id:
            values.new_season_year_id === "All"
              ? null
              : values.new_season_year_id,
        };
        const key = "total_ots"
        const response = await axios.post(`${BASEURL}getAll/DownloadSkuLookupDataPk`, { distributorParam, filters, key }, {
          responseType: "blob", // Important!
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const blob = new Blob([response.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "Total-OTS-PK.xlsx");

        notification.destroy({ key: notificationKey });
        notification.success({
          message: "Download Successful",
          description: "Your Excel report has been downloaded.",
          className: "toast-success",
        });
      });
    } catch (error) {
      console.error("Download failed", error);

      // Destroy loader and show error notification
      notification.destroy({ key: notificationKey });
      notification.error({
        message: "Download Failed",
        description: "Something went wrong while downloading the Excel report.",
        className: "toast-error",
      });
    }
  };



  useEffect(() => {
    dispatch(getStyle(token, menuId));
    dispatch(getProductType(token, values));
    dispatch(getGenderCategory(token, menuId));
    dispatch(getSeason(token, menuId));
    dispatch(getProductStatus(token, menuId));
    dispatch(getProductClass(token, menuId));
    dispatch(getSize(token, menuId));
    dispatch(getGender(token, menuId));
    dispatch(getFitCategory(token, menuId));
    dispatch(getWashName(token, menuId));
    dispatch(getSeasonYear(token, menuId));
    dispatch(getAdminLocation(token, menuId));
  }, [dispatch, menuId, token]);

  useEffect(() => {
    if (allSesion) {
      setIsChecked([]);
    }
  }, [allSesion]);

  useEffect(() => {
    if (allStatus) {
      setIsChecked2([]);
    }
  }, [allStatus]);

  useEffect(() => {
    if (allPC) {
      setIsPCChecked([]);
    }
  }, [allPC]);

  const handlePrint = () => {
    window.print();
  };

  const handleGender = (gender_id) => {
    form.setFieldsValue({
      gender_category_id: "All",
      style_id: "All",
      sku: "All",
    });
  };

  const handleStyle = (gender_category_id) => {
    form.setFieldsValue({
      style_id: "All",
      sku: "All",
    });
  };

  const handleSku = (sku_id) => {
    if (sku_id === null) {
      dispatch(getSku(token, null, null, null));
    } else {

    }
    form.setFieldsValue({
      sku: "All",
    });
  };

  function debounce(cb, delay = 1000) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        cb(...args);
      }, delay);
    };
  }

  const handleSkuSearch = () => {
    dispatch(getSku(token, null, null, null));
  };

  const optimizedFn = useCallback(debounce(handleSkuSearch), []);


  let sizeChartRendering = form.getFieldValue("gender_id")
  let sizeChartRenderingSKU = form.getFieldValue("sku")


  const isRestrictedSize = (gender, size) => {
    return (
      (gender === "Men" && size === "28") ||
      (gender === "Women" && (size === "23" || size === "23P")) ||
      size === "XS" ||
      (gender === "Kids" && (size === "7" || size === "8" || size === "S"))
    );
  };

  const getQtyValueByKey = (data, qtyKey, filters) => {
    const size = data.all_locations?.size_1;
    const gender = data.gender_name;

    let suffix = parseInt(qtyKey.split("_")[1]); // e.g., qty_3 → 3

    // Special shift logic
    if (size === "7") {
      suffix = suffix - 6;
    } else if (size === "8") {
      suffix = suffix - 7;
    } else if (size === "S") {
      suffix = suffix - 2; // qty_3 -> qty_1, qty_4 -> qty_2, etc.
    }

    // Handle restricted sizes (ignore if size is 7, 8, or S)
    const isRestricted = isRestrictedSize(gender, size);
    if (!["7", "8", "S"].includes(size) && isRestricted) {
      if (suffix === 1) return 0;
      suffix = suffix - 1;
    }

    const baseQtyKey = `ots_qty_${suffix}`;
    const baseQty = Number(data.all_locations?.[baseQtyKey]) || 0;

    const sources = [
      { key: "BERGEN ECOM", field: `ecommerce_qty_${suffix}` },
      { key: "NORD D2C", field: `nord_qty_${suffix}` },
      { key: "VERISHOP D2C", field: `verishop_qty_${suffix}` },
      { key: "Neiman D2C", field: `neiman_qty_${suffix}` },
      { key: "Saks D2C", field: `saks_qty_${suffix}` },
      { key: "Moda D2C", field: `moda_qty_${suffix}` },
      { key: "Macys D2C", field: `macys_qty_${suffix}` },
      { key: "Anthro D2C", field: `anthro_qty_${suffix}` }
    ];

    const additionalQty = sources.reduce((total, source) => {
      return total + (filters.includes(source.key) ? Number(data.all_locations?.[source.field]) || 0 : 0);
    }, 0);

    return baseQty + additionalQty;
  };

  const kidsColumns = kidsSizes.map(({ titles, key, border, width }) =>
    createNestedColumn(
      titles,
      key,
      width || 50,
      {
        className: border ? "Border-Right-table border-z-index-1" : "",
        render:
          key === "building"
            ? undefined // 👈 stage ke liye kuch render mat karo
            : (text, data) => getQtyValueByKey(data, key, filters),
      }
    )
  );

  const womenColumns = womenSizes.map(({ titles, key, border, width }) =>
    createNestedColumn(
      titles,
      key,
      width || 50,
      {
        className: border ? "Border-Right-table border-z-index-1" : "",
        render:
          key === "building"
            ? undefined
            : (text, data) => getQtyValueByKey(data, key, filters),
      }
    )
  );

  const menColumns = menSizes.map(({ titles, key, border, width }) =>
    createNestedColumn(
      titles,
      key,
      width || 50,
      {
        className: border ? "Border-Right-table border-z-index-1" : "",
        render:
          key === "building"
            ? undefined
            : (text, data) => getQtyValueByKey(data, key, filters),
      }
    )
  );

  const allColumns = allSizes.map(({ titles, key, border, width }) =>
    createNestedColumn(
      titles,
      key,
      width || 50,
      {
        className: border ? "Border-Right-table border-z-index-1" : "",
        render:
          key === "building"
            ? undefined
            : (text, data) => getQtyValueByKey(data, key, filters),
      }
    )
  );


  const colums = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      width: 40,
      render: (text, record, index) => {
        return index + 1;
      },
    },
    {
      title: "SKU",
      dataIndex: "sku",
      key: "sku",
      render: (text, record) => {
        return (
          <Link
            style={{
              color: "blue",
              textDecoration: "underline",
            }}
            to={{
              pathname: `/sku-lookup-pk-stock?sku=${record.sku}`,
              state: data,
            }}
            target="_blank"
          >
            {record.sku}
          </Link>
        );
      },
      sorter: (a, b) => {
        return a.sku - b.sku;
      },
    },
    {
      title: "Inseam",
      dataIndex: "inseam",
      key: "inseam",
      sorter: (a, b) => {
        return a.inseam - b.inseam;
      },
    },
    {
      title: "Style",
      dataIndex: "style_name",
      key: "style_name",
      sorter: (a, b) => {
        if ((a.style_name !== null) & (b.style_name !== null)) {
          return a.style_name.localeCompare(b.style_name);
        }
      },
    },
    {
      title: "Wash",
      dataIndex: "wash_name",
      key: "wash_name",
      sorter: (a, b) => {
        if ((a.wash_name !== null) & (b.wash_name !== null)) {
          return a.wash_name.localeCompare(b.wash_name);
        }
      },
    },
    {
      title: "Current Season",
      dataIndex: "current_season",
      key: "current_season",
      sorter: (a, b) => {
        if ((a.current_season !== null) & (b.current_season !== null)) {
          return a.current_season.localeCompare(b.current_season);
        }
      },
    },
    {
      title: "Gender",
      dataIndex: "gender_name",
      key: "gender_name",
      sorter: (a, b) => {
        if ((a.gender_name !== null) & (b.gender_name !== null)) {
          return a.gender_name.localeCompare(b.gender_name);
        }
      },
    },
    {
      title: "Fit Category",
      dataIndex: "fit_category_name",
      key: "fit_category_name",
      sorter: (a, b) => {
        if ((a.fit_category_name !== null) & (b.fit_category_name !== null)) {
          return a.fit_category_name.localeCompare(b.fit_category_name);
        }
      },
    },
    {
      title: "WS",
      dataIndex: "ws",
      key: "ws",
      align: "right",
      sorter: (a, b) => {
        return a.sku - b.sku;
      },
    },
    {
      title: "RTL",
      dataIndex: "rtl",
      key: "rtl",
      align: "right",
      sorter: (a, b) => {
        return a.sku - b.sku;
      },
    },
    //for Kids
    sizeChartRendering === "Kids" || (sizeChartRenderingSKU !== "All" && skuLookUpDataPkStock?.payload?.data[0]?.gender_name === "Kids") ? (
      {
        children: kidsColumns
      }
    )
      : sizeChartRendering === "Women" || (sizeChartRenderingSKU !== "All" && skuLookUpDataPkStock?.payload?.data[0]?.gender_name === "Women") ? (
        // // for Women
        {
          children: womenColumns
        }
      )
        : sizeChartRendering === "Men" || (sizeChartRenderingSKU !== "All" && skuLookUpDataPkStock?.payload?.data[0]?.gender_name === "Men") ? (

          // for Men
          {
            children: menColumns
          }) :

          ///for All
          {
            children: allColumns
          },
    {
      title: "Total",
      align: "right",
      className: "border-z-index-1",
      render: (text, record) => {
        return (
          <>
            {" "}
            {Number(record.all_locations.final_ots) +
              (filters.includes("BERGEN ECOM") &&
                Number(record.all_locations.ecommerce)) +
              (filters.includes("NORD D2C") &&
                Number(record.all_locations.nord)) +
              (filters.includes("VERISHOP D2C") &&
                Number(record.all_locations.verishop)) +
              (filters.includes("Neiman D2C") &&
                Number(record.all_locations.neiman)) +
              (filters.includes("Saks D2C") &&
                Number(record.all_locations.saks)) +
              (filters.includes("Moda D2C") &&
                Number(record.all_locations.moda)) +
              (filters.includes("Macys D2C") &&
                Number(record.all_locations.macys)) +
              (filters.includes("Anthro D2C") &&
                Number(record.all_locations.anthro))
            }
          </>
        );
      },
      sorter: (a, b) => {
        const sumA =
          Number(a.all_locations.final_ots) +
          (filters.includes("BERGEN ECOM") && Number(a.all_locations.ecommerce)) +
          (filters.includes("NORD D2C") && Number(a.all_locations.nord)) +
          (filters.includes("VERISHOP D2C") && Number(a.all_locations.verishop)) +
          (filters.includes("Neiman D2C") && Number(a.all_locations.neiman)) +
          (filters.includes("Saks D2C") && Number(a.all_locations.saks)) +
          (filters.includes("Moda D2C") && Number(a.all_locations.moda)) +
          (filters.includes("Macys D2C") && Number(a.all_locations.macys)) +
          (filters.includes("Anthro D2C") && Number(a.all_locations.anthro));

        const sumB =
          Number(b.all_locations.final_ots) +
          (filters.includes("BERGEN ECOM") && Number(b.all_locations.ecommerce)) +
          (filters.includes("NORD D2C") && Number(b.all_locations.nord)) +
          (filters.includes("VERISHOP D2C") && Number(b.all_locations.verishop)) +
          (filters.includes("Neiman D2C") && Number(b.all_locations.neiman)) +
          (filters.includes("Saks D2C") && Number(b.all_locations.saks)) +
          (filters.includes("Moda D2C") && Number(b.all_locations.moda)) +
          (filters.includes("Macys D2C") && Number(b.all_locations.macys)) +
          (filters.includes("Anthro D2C") && Number(b.all_locations.anthro));
        return sumA - sumB;
      },
    },
    {
      title: "Image",
      dataIndex: "image_url",
      key: "image_url",
      width: 50,
      render: (text, record) => (
        <div className="image-nu">
          <Image src={text} />
        </div>
      ),
    }
  ];

  return (
    <div className="header_class business_header_oms">
      <div className="row justify-content-between business_class_oms distributor">
        <div className="col-3 d-flex align-items-start box-space">
          <div className="logobrand">
            <img id="ImgLogo" alt="logo" src={logo} />
          </div>
        </div>
        {/* <div className="col-sm-6 box-space pl-sm-0">
                    <div className="brand-para">
                        <div>DL1961 Premium Denim Inc.</div>
                        <div>121 Varick Street</div>
                        <div>4th Floor</div>
                        <div>New York, NY 10013</div>
                        <div>(P) 646-514-9736</div>
                        <div>(F) 212-991-9989</div>
                        <div>(E) sales@DL1961.com</div>
                    </div>
                </div> */}
        <div className="col-4 box-space right-content-header text-right">
          <div className=" d-flex justify-content-end">
            <div className=" d-flex justify-content-end mr-8">
              <div className="print_icon printing_class">
                <i
                  onClick={handlePrint}
                  id="Image1"
                  title="Print"
                  alt="Print"
                  src={btnPrint}
                  className="fa-solid fa-print"
                ></i>
              </div>
              <div className="print_icon printing_class" onClick={handleDownload}>
                {/* <CSVLink
                  filename={"Total-OTS.csv"}
                  data={excelData}
                  onClick={downloadExcelFileData}
                  style={{ display: "flex" }}
                > */}
                <input
                  type="image"
                  name="ImgExcel"
                  alt="Export to excel"
                  id="ImgExcel"
                  title="Export to excel"
                  src={xlsx}
                  height={14}

                />
                {/* </CSVLink> */}
              </div>
            </div>
            <span style={{ fontSize: "small", fontWeight: "bolder" }}>
              Total OTS PK
              <br />
              Rpt # 489
              <br />
              <p className=" mb-0">Rpt # 001_V4</p>
              Login as:{" "}
              <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                {userName}
              </span>
            </span>
          </div>
        </div>
      </div>

      <div className="business_class_oms mb-2 distributor">
        <Form form={form} name="control-hooks" onFinish={onFinish}>
          <div className="main_form row">
            <div className="col-12">
              <hr className="my-1" />
              <div>
                <label htmlFor="">Product Status</label>
                <div className="checkboxes">
                  <div className="checkbox_content">
                    <Form.Item name="current_status_id" className=" mb-0">
                      <Checkbox checked={allStatus} onChange={statusSelectAll}>
                        All
                      </Checkbox>
                    </Form.Item>
                  </div>
                  {productStatus &&
                    productStatus?.payload?.data.map((it, index) => {
                      return (
                        <div key={index} className="checkbox_content">
                          <Form.Item name="current_status_id">
                            <Checkbox
                              checked={
                                allStatus
                                  ? false
                                  : isChecked2.includes(it.product_status_id)
                              }
                              onChange={(e) =>
                                isCheckboxChecked2(
                                  it.product_status_id,
                                  e.target.checked
                                )
                              }
                            >
                              {it.product_status_name}
                            </Checkbox>
                          </Form.Item>
                        </div>
                      );
                    })}
                </div>
              </div>
              {/* <hr className="my-1" />
              <div>
                <label htmlFor="">Locations</label>
                <div className="checkboxes">
                  {allFilters &&
                    allFilters.map((it, index) => {
                      return (
                        <div key={index} className="checkbox_content">
                          <Form.Item name="current_status_id">
                            <Checkbox

                              onChange={(e) => isFilter(it, e.target.checked)}
                            >
                              {it}
                            </Checkbox>
                          </Form.Item>
                        </div>
                      );
                    })}
                </div>
              </div> */}
              <hr className="my-1" />
              <div className="main_form row">
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Gender
                    </label>
                    <div className="w-100">
                      {/* <Form.Item name="gender_id" initialValue={"All"}> */}
                      <Select
                        className={"select_Inputs"}
                        showSearch
                        optionFilterProp="children"
                        size="small"
                        defaultValue={"All"}
                        onChange={(e) => {
                          console.log("eeeeeeeeeee", e);
                          setIsGenerate(e);
                        }}
                      >
                        <Option value={null}>All</Option>
                        {gender &&
                          gender?.payload?.data.map((it, index) => {
                            return (
                              <Option key={index} value={it.gender_name}>
                                {it.gender_name}
                              </Option>
                            );
                          })}
                      </Select>
                      {/* </Form.Item> */}
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Season
                    </label>
                    <div className=" w-100">
                      <Form.Item name="season_id" initialValue={"All"}>
                        <Select
                          defaultValue={form.getFieldValue().season_name}
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          filterSort={(optionA, optionB) =>
                            optionB?.value !== null ?
                              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                          }
                        >
                          <Option value={null}>All</Option>
                          {season &&
                            season?.payload?.data?.map((status, index) => {
                              return (
                                <Option key={index} value={status.season_name}>
                                  {status.season_name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Wash
                    </label>
                    <div className="w-100">
                      <Form.Item name="wash_id" initialValue={"All"}>
                        <Select
                          defaultValue={form.getFieldValue().wash_name}
                          className={"select_Inputs"}
                          showSearch

                          optionFilterProp="children"
                          size="small"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          filterSort={(optionA, optionB) =>
                            optionB?.value !== null ?
                              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                          }
                        >
                          <Option value={null}>All</Option>
                          {wash &&
                            wash?.payload?.data?.map((status, index) => {
                              return (
                                <Option key={index} value={status.wash_name}>
                                  {status.wash_name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                {/*Second*/}
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Category
                    </label>
                    <div className="w-100">
                      <Form.Item initialValue={"All"} name="gender_category_id">
                        <Select
                          className={"select_Inputs"}
                          showSearch

                          optionFilterProp="children"
                          size="small"
                          onChange={(e) => handleStyle(e)}
                          filterSort={(optionA, optionB) =>
                            optionB?.value !== null ?
                              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                          }
                        >
                          <Option value={null}>All</Option>
                          {genderCategoryChange &&
                            genderCategoryChange?.payload?.data.length >= 0
                            ? genderCategoryChange &&
                            genderCategoryChange?.payload?.data.map(
                              (it, index) => {
                                return (
                                  <Option
                                    key={index}
                                    value={it.gender_category_name}
                                  >
                                    {it.gender_category_name}
                                  </Option>
                                );
                              }
                            )
                            : genderCategory &&
                            genderCategory?.payload?.data.map((it, index) => {
                              return (
                                <Option
                                  key={index}
                                  value={it.gender_category_name}
                                >
                                  {it.gender_category_name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </div>
              <div className="main_form row form-margin">
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Sku
                    </label>
                    <div className="w-100">
                      {/* <Form.Item name="sku" initialValue={"All"}> */}
                      <Select
                        notFoundContent={
                          Sku.loading ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Loader
                                type="Oval"
                                color="#3c4b58"
                                height={20}
                                width={20}
                              />
                            </div>
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                              }}
                            >
                              No Data
                            </div>
                          )
                        }
                        className={"select_Inputs"}
                        showSearch
                        onSearch={(value) => {
                          optimizedFn(value);
                        }}
                        onChange={(e) => {
                          console.log("eeeeeeeeeee", e);
                          setIsSKU(e);
                        }}
                        defaultValue={"All"}
                        optionFilterProp="children"
                        size="small"
                      >
                        <Option value="All">All</Option>
                        {Sku &&
                          Sku?.payload?.data.map((it, index) => {
                            return (

                              <Option key={index} value={it.sku}>
                                {it.sku}
                              </Option>
                            );
                          })}
                      </Select>
                      {/* </Form.Item> */}
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Style
                    </label>
                    <div className="w-100">
                      <Form.Item initialValue={"All"} name="style_id">
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          onChange={(e) => handleSku(e)}
                          filterSort={(optionA, optionB) =>
                            optionB?.value !== null ?
                              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                          }
                        >
                          <Option value={null}>All</Option>
                          {styleChange && styleChange?.payload?.data.length >= 0
                            ? styleChange &&
                            styleChange?.payload?.data.map((style, index) => {
                              return (
                                <Option key={index} value={style.style_name}>
                                  {style.style_name}
                                </Option>
                              );
                            })
                            : style &&
                            style?.payload?.data.map((style, index) => {
                              return (
                                <Option key={index} value={style.style_name}>
                                  {style.style_name}
                                </Option>
                              );
                            })}
                          {/* {style &&
                            style?.payload?.data.map((style, index) => {
                              return (
                                <Option key={index} value={style.style_id}>
                                  {style.style_name}
                                </Option>
                              );
                            })} */}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  {/* <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">Wash</label>
                    <div className="w-100">
                      <Form.Item name="wash_id" initialValue={"All"}>
                        <Select
                          defaultValue={form.getFieldValue().wash_name}
                          className={"select_Inputs"}
                          showSearch
                        
                          optionFilterProp="children"
                          size="small"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        >
                          <Option value={null}>All</Option>
                          {wash &&
                            wash?.payload?.data?.map(
                              (status, index) => {
                                return (
                                  <Option
                                    key={index}
                                    value={status.wash_name}
                                  >
                                    {status.wash_name}
                                  </Option>
                                );
                              }
                            )}
                        </Select>
                      </Form.Item>
                    </div>
                  </div> */}
                </div>
                <div className="col-12 col-md-3">
                  {/* <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">Pending Till</label>
                    <div className="w-100">
                      <Form.Item
                        name="as_on_date"
                        className="full_date"
                        initialValue={moment().endOf('year')}
                      >
                        <DatePicker
                          size="small"
                          onChange={onChangeDate}
                          format={dateFormatList}

                          defaultValue={moment().format("MM-DD-YYYY")}
                        />
                      </Form.Item>
                    </div>
                  </div> */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginTop: "3px",
                      float: "right",
                    }}
                  >
                    {/* <label className=" no_visibility">none</label> */}
                    <Button
                      style={{ width: "fit-content" }}
                      type="primary"
                      htmlType="submit"
                      className="submit-btn-btm m-0"
                    >
                      Generate
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>
      <div >
        <div className="overflow"
          style={{
            overflowY: "scroll",
          }}>
          {skuLookUpDataPkStock?.payload?.data !== undefined ? (
            data.length > 0 ? (
              <Table
                className="fix-scroll-table  table-header-sticky  border-line-th  bottom-align-th  table-td-border-right  th-general-style  
              td-general-style even-tr-style border"
                ref={tableRef}
                size="small"
                bordered={false}
                type="company"
                headerClassName="abc"
                dataSource={data}
                columns={colums}
                loading={skuLookUpDataPkStock.loading}
                pagination={{
                  defaultCurrent: 1,
                  defaultPageSize: 50,
                  pageSizeOptions: [100, 200, 500],
                }}
                scroll={{ x: "max-content" }}
              // summary={(pageData) => {
              //   let Quantity = pageData.reduce(function (
              //     previousValue,
              //     currentValue
              //   ) {
              //     return (previousValue += parseFloat(
              //       currentValue.sum_quantity
              //     ));
              //   },
              //     0);
              //   return (
              //     <>
              //       <Table.Summary.Row>
              //         {/* <Table.Summary.Cell colSpan={2}>Total Quantity : {numeral(totalQuantity()).format("0,00,0")}
              //     </Table.Summary.Cell> */}
              //         <Table.Summary.Cell></Table.Summary.Cell>
              //         <Table.Summary.Cell></Table.Summary.Cell>
              //         <Table.Summary.Cell></Table.Summary.Cell>
              //         <Table.Summary.Cell></Table.Summary.Cell>
              //         <Table.Summary.Cell></Table.Summary.Cell>
              //         <Table.Summary.Cell></Table.Summary.Cell>
              //         <Table.Summary.Cell></Table.Summary.Cell>
              //         <Table.Summary.Cell></Table.Summary.Cell>
              //         <Table.Summary.Cell></Table.Summary.Cell>
              //         <Table.Summary.Cell>
              //           <p
              //             style={{ textAlign: "right" }}
              //             className="totalquantity"
              //           >
              //             Total :
              //           </p>{" "}
              //         </Table.Summary.Cell>
              //         <Table.Summary.Cell>
              //           <p
              //             style={{ textAlign: "right" }}
              //             className="totalquantity"
              //           >
              //             {bergotal.toLocaleString("en-US")}
              //           </p>
              //         </Table.Summary.Cell>
              //         <Table.Summary.Cell>
              //           <p
              //             style={{ textAlign: "right" }}
              //             className="totalquantity"
              //           >
              //             {trnsTotal.toLocaleString("en-US")}
              //           </p>
              //         </Table.Summary.Cell>
              //         <Table.Summary.Cell>
              //           <p
              //             style={{ textAlign: "right" }}
              //             className="totalquantity"
              //           >
              //             {pkTotal.toLocaleString("en-US")}
              //           </p>
              //         </Table.Summary.Cell>
              //         <Table.Summary.Cell>
              //           <p
              //             style={{ textAlign: "right" }}
              //             className="totalquantity"
              //           >
              //             {prodTotal.toLocaleString("en-US")}
              //           </p>
              //         </Table.Summary.Cell>
              //         <Table.Summary.Cell>
              //           <p
              //             style={{ textAlign: "right" }}
              //             className="totalquantity"
              //           >
              //             {pendTotal.toLocaleString("en-US")}
              //           </p>
              //         </Table.Summary.Cell>
              //         <Table.Summary.Cell>
              //           <p
              //             style={{ textAlign: "right" }}
              //             className="totalquantity"
              //           >
              //             {intTotal.toLocaleString("en-US")}
              //           </p>
              //         </Table.Summary.Cell>
              //         <Table.Summary.Cell>
              //           <p
              //             style={{ textAlign: "right" }}
              //             className="totalquantity"
              //           >
              //             {otsTotal.toLocaleString("en-US")}
              //           </p>
              //         </Table.Summary.Cell>
              //       </Table.Summary.Row>
              //     </>
              //   );
              // }}
              />
            ) : (
              <div className="no-Data">
                {/* {} */}
                <h1>No Data</h1>
              </div>
            )
          ) : (
            loading && (
              <div className="loader" style={{ marginTop: "20px" }}>
                <Spin size="medium" />
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default TotalOtsPk;
